<div class="alert alert-secondary" role="alert">
    <p class="mb-0"><b>Note</b> Submitting the address of a local branch or any address different from the official registered company address might produce a mismatch with a negative impact on the Trust Score.</p>
</div>
<form [formGroup]="businessAddressForm">
    <div class="form-group mb-3">
        <label class="form-label">Business Name</label>
        <input type="text" class="form-control" formControlName="businessName" placeholder="Appleseed Corporation" [class.is-invalid]="businessName.invalid && (businessName.dirty || businessName.touched)" required>
        @if (businessName.invalid && (businessName.dirty || businessName.touched)) {
        @if (businessName.errors.required) { <div class="input-validation-msg">Business Name is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Address Line 1</label>
        <input type="text" class="form-control" formControlName="street" placeholder="123 Main Street" [class.is-invalid]="street.invalid && (street.dirty || street.touched)" required>
        @if (street.invalid && (street.dirty || street.touched)) {
        @if (street.errors.required) { <div class="input-validation-msg">Address Line 2 is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Address Line 2</label>
        <input type="text" class="form-control" formControlName="streetSecondary" placeholder="Apt. 105" [class.is-invalid]="streetSecondary.invalid && (streetSecondary.dirty || streetSecondary.touched)">
    </div>
    <div class="form-group mb-3">
        <label class="form-label">City</label>
        <input type="text" class="form-control" formControlName="city" placeholder="Philadelphia" [class.is-invalid]="city.invalid && (city.dirty || city.touched)" required>
        @if (city.invalid && (city.dirty || city.touched)) {
        @if (city.errors.required) { <div class="input-validation-msg">City is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">State</label>
        <select id="REGION" class="form-select" formControlName="region" [class.is-invalid]="region.invalid && (region.dirty || region.touched)" required>
            <option [value]="null">Select a State</option>
            @for (state of states; track state.abbreviation) {
            <option [value]="state.abbreviation">{{state.name}}</option>
            }
        </select>
        @if (region.invalid && (region.dirty || region.touched)) {
        @if (region.errors.required) { <div class="input-validation-msg">State is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Postal Code</label>
        <input type="text" class="form-control" formControlName="postalCode" placeholder="90210" [class.is-invalid]="postalCode.invalid && (postalCode.dirty || postalCode.touched)" required>
        @if (postalCode.invalid && (postalCode.dirty || postalCode.touched)) {
        @if (postalCode.errors.required) { <div class="input-validation-msg">Postal Code is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Country</label>
        <select id="ISO_COUNTRY" class="form-select" formControlName="isoCountry" [class.is-invalid]="isoCountry.invalid && (isoCountry.dirty || isoCountry.touched)" required>
            <option selected disabled [value]="null">Select a Country</option>
            @for (country of countryList; track country.value) {
            <option [value]="country.value">{{country.name}}</option>
            }
        </select>
        @if (isoCountry.invalid && (isoCountry.dirty || isoCountry.touched)) {
        @if (isoCountry.errors.required) { <div class="input-validation-msg">Country is required.</div> }
        }
    </div>
</form>
<button type="button" class="btn btn-primary w-100" (click)="submitForm();" [disabled]="!businessAddressForm.valid">Next</button>